<h2 mat-dialog-title *ngIf="data?.title" class="text-center">{{ data.title }}</h2>
<mat-dialog-content>
    <p class="text-center">
        {{ data?.message || 'Are you sure?' }}
    </p>
</mat-dialog-content>
<mat-dialog-actions class="py-0" align="center">
    <button mat-button color="primary" (click)="confirm()">{{ data?.confirmText || 'Yes' }}</button>
    <button mat-button color="warn" mat-dialog-close>{{ data?.cancelText || 'No' }}</button>
</mat-dialog-actions>